module.exports = __webpack_public_path__ + "media/images/countrysquared/vc-28066943774ac57097e72a76012d9b24.svg";